export default __webpack_public_path__ + "media/hannah.e0f98d14.jpg";